import React, { FC, ReactElement } from 'react';
import { Grid, Tooltip, Typography } from '@mui/material';
import { useStyles } from './BaseNotificationTile.styles';
import { NotificationDateFormat } from 'shared/components/Format/NotificationDateFormat';
import classNames from 'classnames';

interface BaseNotificationTileProps {
  message: ReactElement | string;
  image: ReactElement | null;
  date?: string;
  seen?: boolean;
}

export const BaseNotificationTile: FC<BaseNotificationTileProps> = ({
  image = '',
  message = '',
  date,
  seen = false,
}) => {
  const { classes } = useStyles();

  return (
    <Tooltip
      placement="top"
      enterDelay={2000}
      enterNextDelay={2000}
      title={<Typography className={classes.tooltip}>{message}</Typography>}
    >
      <Grid container className={classNames(classes.root, { [classes.notViewed]: !seen })}>
        <Grid className={classes.avatar} item lg={2.5} xs={2.5} sm={1}>
          {image}
        </Grid>
        <Grid item lg={6.5} xs={6.5} sm={10} className={classes.message}>
          {message}
        </Grid>
        <Grid item lg={3} xs={2.5} sm={1} className={classes.date}>
          <NotificationDateFormat date={date as string} />
        </Grid>
      </Grid>
    </Tooltip>
  );
};
